var TablesMixin = {
  data() {
    return {
      actions: {
        selected: {
          icon: 'pi pi-check',
          buttonClass: 'p-button-success'
        },
        unselected: {
          icon: 'pi',
          buttonClass: 'p-button-outlined'
        },
      },
    }
  }
};
export default TablesMixin;